/* (ignored) */


//////////////////
// WEBPACK FOOTER
// vertx (ignored)
// module id = 111
// module chunks = 0